import styled from '@emotion/styled';
import { tokens, Modal, Loader, Divider } from '@hotjar/hotsauce';

export const ModalStyles = {
  Modal: styled(Modal)`
    background: ${tokens.color.white};
    margin: ${tokens.spacer.x6} auto;
    max-height: calc(100vh - ${tokens.spacer.x6} * 2);
    overflow: hidden;
    width: 1036px;
  `,
  ModalBody: styled(Modal.Body)`
    padding: 0;
  `,
  ModalHeader: styled(Modal.Header)`
    border-bottom: 1px solid ${tokens.color.ui_border_light};
  `,
  ProductSelectWraper: styled('div')`
    background: ${tokens.BRAND_COLORS.cobalt_100};
    padding: ${tokens.spacer.x3} ${tokens.spacer.x3} ${tokens.spacer.x3pt5} ${tokens.spacer.x3};
  `,
  Product: styled('div')`
    flex: 1 1 50%;
  `,
  BodyInfo: styled('div')`
    padding: 0 ${tokens.spacer.x3};
    padding: ${tokens.spacer.x3};
  `,
  ModalFooter: styled(Modal.Footer)`
    align-items: center;
    border-top: 1px solid ${tokens.color.ui_border};
    padding: ${tokens.spacer.x2} ${tokens.spacer.x3} ${tokens.spacer.x3};
  `,
  Loader: styled(Loader)`
    flex: 1 1 auto;
  `,
  BundleDiscount: styled('div')`
    color: ${tokens.color.text_light};
    margin-top: ${tokens.spacer.x2};
  `,
  Divider: styled(Divider)`
    border-color: ${tokens.color.neutral_400};
    margin: ${tokens.spacer.x2pt5} 0;
  `,
  ExternalLinkList: styled('ul')`
    padding-left: ${tokens.spacer.x3};
  `,
  ExternalLinkListItem: styled('li')`
    ${tokens.text('body2')};
    margin-bottom: ${tokens.spacer.x0};
    color: ${tokens.color.text_light};
  `,
};
